import { render } from "./PublicNav.vue?vue&type=template&id=8630f4e2&scoped=true"
import script from "./PublicNav.vue?vue&type=script&lang=js"
export * from "./PublicNav.vue?vue&type=script&lang=js"

import "./PublicNav.vue?vue&type=style&index=0&id=8630f4e2&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8630f4e2"]])

export default __exports__